import { render, staticRenderFns } from "./RegistroCargador.vue?vue&type=template&id=cf3ca6e0"
import script from "./RegistroCargador.vue?vue&type=script&lang=js"
export * from "./RegistroCargador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports